import { useEffect, useState } from 'react';

export function useVersionCheck() {
  const [hasUpdate, setHasUpdate] = useState(false);

  const check = async () => {
    try {
      const res = await fetch(`${process.env.PUBLIC_URL || ''}/meta.json`, { cache: 'no-cache' });
      const data = await res.json();
      const currentVersion = process.env.REACT_APP_VERSION;

      if (data.version && currentVersion && data.version !== currentVersion) {
        setHasUpdate(true);
        // Optional: broadcast event
        window.dispatchEvent(new Event('update-available'));
      }
    } catch (err) {
      console.warn("Version check failed:", err);
    }
  };

  useEffect(() => {
    check(); // runs once on load
  }, []);

  return hasUpdate;
}

// Utility method for manual checks
export async function checkForAppUpdate() {
  try {
    const res = await fetch(`${process.env.PUBLIC_URL || ''}/meta.json`, { cache: 'no-cache' });
    const data = await res.json();
    const currentVersion = process.env.REACT_APP_VERSION;

    if (data.version && currentVersion && data.version !== currentVersion) {
      window.dispatchEvent(new Event('update-available'));
    }
  } catch (err) {
    console.warn("Manual version check failed:", err);
  }
}
